import { gql } from '@apollo/client'
import React from 'react'

import { importsClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useImportState = () => React.useContext(Context)
export const useImport = () => useImportState()?.import

const QUERY = gql`
  query Import($id: ID) {
    import(id: $id) {
      id
      entity
      status
      insertedAt
      createdBy {
        id
        name
      }
      outputDocument {
        id
        src
      }
    }
  }
`

const ImportsLoader = ({ id, children }) => {
  const [pollInterval, setPollInterval] = React.useState(1500)
  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: importsClient,
    pollInterval
  })

  React.useEffect(() => {
    if (['error', 'done'].includes(data?.import?.status)) {
      setPollInterval(false)
    }
  }, [data?.import?.status])

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ImportsLoader
